import { type FC } from 'react';
import { Select, Space, Textarea } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import { Section } from 'components';
import styles from '../parts-only-job.module.scss';

type Props = WithOptionalDataTest;

export const JobDetails: FC<Props> = (props) => {
  const { dataTestId } = props;

  return (
    <Section title="Job Details" dataTestId={dataTestId}>
      <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
        <Select.$
          required
          dataTestId="service-type"
          label="Service Type: "
          name="serviceType"
          className={styles.partsOnlyJob__formItem}
          options={[
            {
              label: 'Normal',
              value: 'N',
            },
            {
              label: 'Technician Warranty',
              value: 'T',
            },
            {
              label: 'Company Warranty',
              value: 'C',
            },
          ]}
          rules={[{ required: true }]}
        />
        <Textarea.$
          dataTestId="prob-description"
          name="description"
          placeholder={'Please enter a short note on what is being supplied.'}
          label="Prob Description:"
          rules={[{ required: true }]}
          className={styles.partsOnlyJob__formItem}
          style={{ maxWidth: 360, height: 100 }}
        />
      </Space.$>
    </Section>
  );
};
